import { Card, Divider } from "antd"
import { FieldArray, FormSection } from "redux-form"
import React, { ReactNode } from "react"

import "./style.less"
import { DocumentsContainer } from "./DocumentsContainer"
import { FieldArrayFieldsProps } from "redux-form/lib/FieldArray"
import { ConditionalLink, TitledLink } from "../../../types"
import { MoveUpButton } from "../MoveUpButton"
import { VisibilityButton } from "../VisibilityButton"
import { DocumentFields } from "./DocumentFields"
import { RemoveButton } from "../RemoveButton"

export type Props = {
  fieldName: string
  customUploadRequest: () => Promise<void>
  cardTitle: ReactNode
  cardDescription: ReactNode
  multiple?: boolean
  acceptedFileExtensions?: string[]
}

export const DocumentsStep = ({
  fieldName,
  customUploadRequest,
  multiple,
  cardTitle,
  cardDescription,
  acceptedFileExtensions,
}: Props) => {
  const documentFileExtensions = ["oft", "pdf", "doc", "docx", "dot", "odt", "msg"]
  const tableFileExtensions = ["csv", "xls", "xlsx", "xlsb", "xlsm"]
  const slideFileExtensions = ["ppt", "pptx"]
  const fileExtensions = acceptedFileExtensions || [
    ...documentFileExtensions,
    ...tableFileExtensions,
    ...slideFileExtensions,
  ]

  return (
    <FormSection name={fieldName} className="fade-in">
      <Card title={cardTitle} bordered={false}>
        {cardDescription}
      </Card>
      <FieldArray name="conditionalList" component={DocumentsContainer} suffix={<Divider />}>
        {(
          name: string,
          field: ConditionalLink,
          index: number,
          fields: FieldArrayFieldsProps<ConditionalLink>
        ) => (
          <FormSection
            name={name}
            component={DocumentFields}
            disabled={!field.enabled}
            field={field}
          >
            {multiple && (
              <MoveUpButton disabled={index === 0} onMoveUp={() => fields.swap(index, index - 1)} />
            )}
            <VisibilityButton
              visible={field.enabled}
              onVisibilityChange={() =>
                fields.splice(index, 1, { ...field, enabled: !field.enabled })
              }
              target={"document"}
            />
          </FormSection>
        )}
      </FieldArray>
      <FieldArray
        name="staticList"
        component={DocumentsContainer}
        createNew={({ url, name }: { url: string; name: string }) => ({ url, title: name })}
        dragAndDropProps={{
          acceptedFileExtensions: fileExtensions,
          customUploadRequest,
          multiple: Boolean(multiple),
        }}
      >
        {(
          name: string,
          field: TitledLink,
          index: number,
          fields: FieldArrayFieldsProps<TitledLink>
        ) => (
          <FormSection name={name} component={DocumentFields} field={field}>
            {multiple && (
              <MoveUpButton disabled={index === 0} onMoveUp={() => fields.swap(index, index - 1)} />
            )}
            <RemoveButton onRemove={() => fields.remove(index)} target={"document"} />
          </FormSection>
        )}
      </FieldArray>
    </FormSection>
  )
}
